import { useTranslation } from 'react-i18next'
import { Loader2Icon } from 'lucide-react'

import { useSubmitCheckoutComplete } from '../hooks/use-submit-checkout-complete'

export const CheckoutComplete = () => {
  const { t } = useTranslation()

  useSubmitCheckoutComplete()

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <p className="text-lg font-bold">{t('Please wait while we process your payment')}</p>
      <div className="relative">
        <div className="absolute -translate-x-1/2">
          <Loader2Icon className="h-20 w-20 animate-spin" />
        </div>
      </div>
    </div>
  )
}
